var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classList },
    [
      _c("v-icon", {
        staticClass: "price-card__orka-card",
        staticStyle: { width: "259px", height: "170px" },
        attrs: { name: "symbols/cards/" + _vm.card.type }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "price-card__wrapper" },
        [
          _vm.card.type !== "green"
            ? _c("v-image", {
                staticClass: "price-card__background",
                attrs: {
                  tiny: {
                    default: require("@/images/pattern/pricing/" +
                      _vm.card.type +
                      ".jpg"),
                    retina: require("@/images/pattern/pricing/" +
                      _vm.card.type +
                      "@2.jpg")
                  },
                  alt: "Price Card Background"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "price-card__top" },
            [
              _c("v-icon", {
                staticClass: "price-card__top-icon",
                staticStyle: { width: "64px", height: "57px" },
                attrs: { name: "symbols/letters/a-" + _vm.card.type }
              }),
              _vm._v(" "),
              _c("v-badge", {
                attrs: {
                  label: _vm.$t(_vm.card.head.badge.label),
                  variant: _vm.card.head.badge.variant
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "price-card__head" },
            [
              _c("v-typo", {
                staticClass: "price-card__headline",
                attrs: { variant: "h3" },
                domProps: { innerHTML: _vm._s(_vm.card.head.headline) }
              }),
              _vm._v(" "),
              _c("v-typo", {
                staticClass: "price-card__perex",
                attrs: { variant: "body-paragraph" },
                domProps: { innerHTML: _vm._s(_vm.card.head.perex) }
              }),
              _vm._v(" "),
              _c("v-typo", {
                staticClass: "price-card__price",
                attrs: { element: "p", variant: "h1" },
                domProps: { innerHTML: _vm._s(_vm.card.head.price) }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "price-card__body" },
            _vm._l(_vm.card.body.includes, function(item, itemIndex) {
              return _c(
                "div",
                {
                  key: "priceCardInclude-" + itemIndex,
                  class: [
                    "price-card__include",
                    item.tooltip && _vm.card.body.includes[itemIndex]
                      ? "price-card__include--tooltip"
                      : null
                  ]
                },
                [
                  _c("v-icon", {
                    staticClass: "price-card__icon",
                    attrs: {
                      name: _vm.card.body.includes[itemIndex]
                        ? "ui/yes"
                        : "ui/no"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "price-card__include-item" },
                    [
                      _c("v-typo", {
                        attrs: {
                          classes: [
                            {
                              relative:
                                item.tooltip &&
                                _vm.card.body.includes[itemIndex]
                            }
                          ],
                          variant: "body-paragraph"
                        },
                        domProps: { innerHTML: _vm._s(item.label) }
                      }),
                      _vm._v(" "),
                      item.tooltip
                        ? _c("v-badge", {
                            attrs: {
                              classes: ["badge--tooltip"],
                              label: item.tooltip,
                              variant: item.tooltip === "New" ? "blue" : "black"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "price-card__bottom" },
            [
              _c("v-typo", {
                staticClass: "price-card__price",
                attrs: { element: "p", variant: "h3" },
                domProps: { innerHTML: _vm._s(_vm.card.head.price) }
              }),
              _vm._v(" "),
              _c(
                "v-button",
                {
                  staticClass: "price-card__bottom-button",
                  attrs: {
                    to: {
                      query: {
                        modal: _vm.appModalName
                      },
                      params: {
                        card: _vm.card.type
                      }
                    },
                    variant: _vm.card.type === "gold" ? "black" : "white"
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("button.get." + _vm.card.type)) +
                      "\n\t\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.currentCardPreview
                ? _c("router-link", {
                    staticClass: "price-card__link",
                    attrs: {
                      to: {
                        path: _vm.path("orka" + _vm.uCFirst(_vm.card.type)),
                        params: {
                          card: _vm.card.type
                        }
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        return (function() {
                          return _vm.pushToGa(_vm.card.type)
                        })($event)
                      }
                    }
                  })
                : _c(
                    "div",
                    { staticClass: "price-card__link" },
                    [
                      _c("v-typo", {
                        attrs: { variant: "body-perex" },
                        domProps: { innerHTML: _vm._s("&nbsp;") }
                      })
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }